import { css } from '@emotion/react'
import React from 'react'

const Footer = () => {
  const FOOTER_SRC =
    '	https://storage.googleapis.com/seniorcare_kiosk/intro/footer/indj_logo.png'
  const TWITTER_SRC =
    'https://storage.googleapis.com/seniorcare_kiosk/intro/footer/twitter.png'
  const INSTA_SRC =
    'https://storage.googleapis.com/seniorcare_kiosk/intro/footer/insta.png'
  const YOUTUBE_SRC =
    'https://storage.googleapis.com/seniorcare_kiosk/intro/footer/youtube.png'
  const CES_SRC =
    'https://storage.googleapis.com/seniorcare_kiosk/intro/footer/ces_logo.png'
  return (
    <div css={footerStyle}>
      <div className="div1">
        <img className="div1_logo" src={FOOTER_SRC} alt="인디제이로고" />
        <div className="div1_sns">
          <img src={TWITTER_SRC} alt="트위터" />
          <img src={INSTA_SRC} alt="인스타" />
          <img src={YOUTUBE_SRC} alt="유튜브" />
          <img src={CES_SRC} alt="CES" />
        </div>
      </div>
      <div className="div2">
        <div className="div2_notice">
          <a
            target="_blank"
            href="https://policy.indj.club/terms_use"
            rel="noreferrer"
          >
            이용약관
          </a>
          <a
            target="_blank"
            href="https://policy.indj.club/terms_private"
            rel="noreferrer"
          >
            개인정보처리방침
          </a>
          <a
            target="_blank"
            href="https://policy.indj.club/terms_loc"
            rel="noreferrer"
          >
            위처정보 이용약관
          </a>
          <a
            target="_blank"
            href="https://policy.indj.club/terms_teenager"
            rel="noreferrer"
          >
            청소년보호정책
          </a>
        </div>
        <div className="div2_info">
          <div className="info_1">
            <span>상호명 : (주)인디제이 l 대표 : 정우주</span>
            <span>개인정보보호책임자 : 김민주</span>
            <span>사업자등록번호 : 490-81-01351</span>
          </div>
          <div className="info_2">
            <span>
              주소 : 서울 종로구 종로 6 광화문우체국 6층 / 광주광역시 동구
            </span>
            <span>금남로 198, 4층 l 제휴 문의 : mst@indj.net</span>
          </div>
        </div>
      </div>
    </div>
  )
}
const footerStyle = css`
  margin-top: 160px;
  padding: 0px 20px;
  background-color: #181818;
  .div1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 60px;
    .div1_logo {
      height: 30px;
      cursor: pointer;
    }
    .div1_sns {
      display: flex;
      align-items: center;
      gap: 8px;
      img {
        height: 32px;
        cursor: pointer;
      }
    }
  }
  .div2 {
    margin-top: 32px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .div2_notice {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      a {
        font-size: 14px;
        font-weight: 400;
        line-height: 150%;
        color: #969696;
        text-decoration: underline;
      }
    }
    .div2_info {
      display: flex;
      flex-direction: column;
      .info_1,
      .info_2 {
        display: flex;
        flex-direction: column;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 150%;
        color: #969696;
      }
    }
  }
  @media screen and (min-width: 1100px) {
    margin: 200px auto 0px;
    padding: 0px;
    .div1 {
      max-width: 1100px;
      margin: 0 auto;
      padding: 48px 0px 0px;
    }
    .div2 {
      max-width: 1100px;
      margin: 34px auto 0px;
      padding-bottom: 48px;
      flex-direction: row-reverse;
      justify-content: space-between;
      gap: 24px;
      .div2_notice {
        flex-wrap: nowrap;
        place-self: start;
      }
      .div2_info {
        flex-direction: column;
        .info_1,
        .info_2 {
          flex-direction: row;
        }
      }
    }
  }
`
export default Footer
